@if (loading) {
  <div class="container py-4">
    <div class="py-5">
      <centered-load-indicator></centered-load-indicator>
    </div>
  </div>
}

@if (!loading && notFound) {
  <div class="container py-4">
    <div class="text-center py-5">
      <h2 class="section-heading">{{ 'viewFeedback.notFound.title' | translate }}</h2>
      <p>{{ 'viewFeedback.notFound.body' | translate }}</p>
    </div>
  </div>
}

@if (!loading && view) {
  @switch (feedbackKind) {
    @case ('stara') {
      <stara-feedback-view [view]="view"></stara-feedback-view>
    }
    @case ('tanvo') {
      <tanvo-feedback-view [view]="view"></tanvo-feedback-view>
    }
    @case ('dance') {
      <dance-feedback-view [view]="view"></dance-feedback-view>
    }
    @case ('gfl') {
      <gfl-feedback-view [view]="view"></gfl-feedback-view>
    }
    @default {
      <agg-feedback-view [view]="view" [token]="token"></agg-feedback-view>
    }
  }
}
